import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Const } from '../const';

import { PastDashboardApiParameter } from '../servicer/models/past-dashboard-api-parameter';
import { DashboardApiResponse} from '../servicer/models/dashboard-api-response';

import { VehicleServiceProvider } from '../servicer/vehicle-service';

/**
 * ダッシュボードを定期間隔で取得するプロバイダー.
 */
@Injectable()
export class PastIntervalReceiverProvider {
  /** ダッシュボードの空のパラメータ. */
  // private readonly dashboardEmptyParameter = {
  //   vin: '',
  //   language: '',
  //   target_datetime: ''
  // } as PastDashboardApiParameter;

  /** ダッシュボードの空のレスポンス. */
  // private readonly dashboardEmptyResponse = {
  //   result: Const.ResponseResult.SUCCESS,
  //   message: '',
  //   user_info: [],
  //   dashboard: []
  // } as DashboardApiResponse;


    /** ダッシュボードの空のパラメータ. */
  private readonly dashboardEmptyParameter = {
    vin: '',
    language: '',
    target_datetime: ''
  } as PastDashboardApiParameter;

    /** ダッシュボードの空のレスポンス. */
  private readonly dashboardEmptyResponse = {
    result: Const.ResponseResult.SUCCESS,
    message: '',
    user_info: [],
    dashboard: []
  } as DashboardApiResponse;

  /** パラメータ情報. */
  public parameter$: BehaviorSubject<PastDashboardApiParameter> = new BehaviorSubject<PastDashboardApiParameter>(this.dashboardEmptyParameter);
  
  /** ダッシュボード情報. */
  // public dashboardInfos$: BehaviorSubject<DashboardApiResponse> = new BehaviorSubject<DashboardApiResponse>(this.dashboardEmptyResponse);
  public dashboardInfos$: BehaviorSubject<DashboardApiResponse> = new BehaviorSubject<DashboardApiResponse>(this.dashboardEmptyResponse);

  /** インターバルのSubscription. */
  private intervalSubscription: Subscription = null;

  constructor(
    public vehicleService: VehicleServiceProvider
  ) { }

  /**
   * 開始.
   *
   * @param parameter ダッシュボードパラメータ
   */
  start(parameter: PastDashboardApiParameter) {
    // 初回のダッシュボード取得
    this.getDashboardInfos(parameter).subscribe(() => {
      let processing = false;

      this.intervalSubscription = Observable.interval(1000)
        .filter(() => !processing)
        .pipe(tap(() => processing = true))
        .flatMap(() => this.getDashboardInfos(parameter))
        .pipe(tap(() => processing = false))
        .subscribe();
    });
  }

  /**
   * 停止.
   */
  stop() {
    // this.dashboardInfos$.next(this.dashboardEmptyResponse);

    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = null;
    }
  }
    
    /**
   * ダッシュボード表示情報を取得します.
   * 定期的に呼び出されるため、エラーが発生しても、何も処理をしません.
   *
   * @param parameter ダッシュボードパラメータ
   */
     private getDashboardInfos(parameter: PastDashboardApiParameter): Observable<DashboardApiResponse> {  
      return this.vehicleService.postPastDashboardRequest(parameter)
        .map((response) => {
          if (response.result === Const.ResponseResult.SUCCESS) {
            this.dashboardInfos$.next(response);
          }
  
          return this.dashboardInfos$.value;
        })
        .catch(() => Observable.of(this.dashboardInfos$.value));
    }
}




// WEBPACK FOOTER //
// ./src/providers/interval-receiver/past-interval-receiver.ts